/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */
import { dataReducer } from './data';
import { stepsReducer } from './steps';
import { userChoiceReducer } from './user-choice';
import { Installation } from './installation';
import Environment from './environment';

/**
 * Define the root reducer.
 */
const rootReducer = combineReducers(
	{
		dataReducer,
		stepsReducer,
		userChoiceReducer,
		Installation,
		Environment
	}
);

// Finally export the root reducer.
export default rootReducer;